import { createPutEndpoint } from '@sonar-software/sonar-http';
import { SonarObjectUser } from '@types';

export type PutSonarObjectUsersBulkRequest = {
	sonarObjectIds: Array<number>;
	users: Array<SonarObjectUser>;
};

export const putSonarObjectUsersBulk = createPutEndpoint<PutSonarObjectUsersBulkRequest>(
	'/api/v3/core/sonar-objects/users/bulk-add'
);
